import { axiosRequestInstance } from 'services/api';
import { axiosInstance } from 'services/httpClient';
import { axiosM2MInstance, hasM2MToken } from 'services/httpClientM2M';

export const setPrimaryHeaders = (token: string) => {
  const bearer = `Bearer ${token}`;
  axiosInstance.defaults.headers.common.Authorization = bearer;
  axiosRequestInstance.defaults.headers.common.Authorization = bearer;
};

export const setM2MHeaders = (token: string) => {
  const bearer = `Bearer ${token}`;
  axiosM2MInstance.defaults.headers.common.Authorization = bearer;
};

export const hasToken = () => hasM2MToken();

// Backwards-compatible name used across the app today
export const setHeaders = (token: string) => {
  setPrimaryHeaders(token);
};
